<template>
  <v-container fluid>
    <v-card class="pa-5 mt-3">
      <v-row>
        <v-col cols="6" md="3">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            outlined
            dense
            clearable
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            outlined
            hide-details
            @change="refreshTable"
            dense
            persistent-hint
            clearable
            v-model="governorate_id"
            :items="governorates"
            item-text="name"
            item-value="id"
            :label="$t('directorates.governorate')"
          ></v-select>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            outlined
            hide-details
            @change="refreshTable"
            dense
            persistent-hint
            clearable
            v-model="directorate_id"
            :items="directorates_filtered"
            item-text="name"
            item-value="id"
            :label="$t('directorates.directorate')"
          ></v-select>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            outlined
            dense
            clearable
            hide-details
            persistent-hint
            :items="status"
            item-text="label"
            item-value="value"
            v-model="status_filter"
            @change="refreshTable"
            :label="$t('schoolRequest.status')"
          ></v-select>
        </v-col>


        <vue-excel-xlsx
            :data="exportItems"
            :columns="headers.map((i)=>{return {label:i.text, field: i.value}})"
            :file-name="'منصة السراج- طلبات الاضمام - '+ (new Date()).toLocaleDateString()"
            :file-type="'xlsx'"
            :sheet-name="'sheet1'"
        >
          <v-btn
              color="primary"
              dark
              class="mb-2"
          >
            {{ $t("export") }}
            <v-icon class="ms-2"> mdi-file-excel</v-icon>
          </v-btn>
        </vue-excel-xlsx>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="schoolRequests"
        :loading="loading"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [50, 100, 200, -1]
        }"
        :server-items-length="total"
        :options.sync="options"
        @update:options="refreshTable"
      >
        <template v-slot:[`item.school_name`]="{ item }">
          {{ item.school_name }}
          <v-btn
              v-if="$store.getters.isInRole(101)"
              color="#25D366"
              @click="openWhatsapp(item)"
              class="ms-1"
              x-small
          >
            واتساب
          </v-btn>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ item.created_at | format_date_time }}
          <br>
          <span v-if="item.status === 'accepted' || item.status === 'rejected'">{{
              item.updated_at | format_date_time
            }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          <span v-if="item.status === 'accepted' || item.status === 'rejected'">{{
              item.updated_at | format_date_time
            }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.note`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  :color="item.comments && item.comments.length > 0 ? 'warning' : 'dark'"
                  @click="viewItemNote(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                mdi-alert-decagram
              </v-icon>
            </template>
            <span> {{ $t("schoolRequest.note") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip v-if="item.status === 'pending'" color="info" small label>
            {{ $t('schoolRequest.pending') }}
          </v-chip>
          <v-chip v-else-if="item.status === 'contacted'" color="warning" small label>
            {{ $t('schoolRequest.contacted') }}
          </v-chip>
          <v-chip v-else-if="item.status === 'accepted'" color="success" small label>
            {{ $t('schoolRequest.accepted') }}
          </v-chip>
          <v-chip v-else-if="item.status === 'rejected'" color="error" small label>
            {{ $t('schoolRequest.rejected') }}
          </v-chip>

          <v-chip v-else-if="item.status === 'postponed'" color="cyan" small label>
            {{ $t('schoolRequest.postponed') }}
          </v-chip>
          <v-chip v-else-if="item.status === 'interested'" color="teal" small label>
            {{ $t('schoolRequest.interested') }}
          </v-chip>
          <v-chip v-else-if="item.status === 'not_interested'" color="purple" small label>
            {{ $t('schoolRequest.not_interested') }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row style="flex-flow: row;" class="mt-1">
            <v-col cols="2">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="info"
                    @click="viewItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span> {{ $t("schoolRequest.view") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="success"
                    @click="changeStatus(item,'accepted')"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-check
                  </v-icon>
                </template>
                <span> {{ $t("schoolRequest.accept") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    @click="transferItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-bank-transfer
                  </v-icon>
                </template>
                <span> {{ $t("schoolRequest.transfer") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="warning"
                    @click="changeStatus(item,'contacted')"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-phone-check-outline
                  </v-icon>
                </template>
                <span> {{ $t("schoolRequest.contacted") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row style="flex-flow: row;" class="mb-1">
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="error"
                      @click="changeStatus(item,'rejected')"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-close
                  </v-icon>
                </template>
                <span> {{ $t("schoolRequest.reject") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="cyan"
                      @click="changeStatus(item,'postponed')"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-lock-alert-outline
                  </v-icon>
                </template>
                <span> {{ $t("schoolRequest.postponed") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="teal"
                      @click="changeStatus(item,'interested')"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-emoticon-excited-outline
                  </v-icon>
                </template>
                <span> {{ $t("schoolRequest.interested") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="purple"
                      @click="changeStatus(item,'not_interested')"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-hand-back-right-outline
                  </v-icon>
                </template>
                <span> {{ $t("schoolRequest.not_interested") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>

    <Dialog
      :onClose="close"
      :dialog="dialog"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      :valid="valid"
      :resetValidation="resetValidation"
      :directorates="directorates"
      @refreshTable="refreshTable"
    />

    <confirm-dialog
        :openDialog="dialogAccept"
        :onClicked="()=> {dialogAccept = false;editItem(editedItem)}"
        :dialog-title="$t('schoolRequest.accepted')"
        tool-bar-color="success"
        :onClose="closeAll"
    />
    <confirm-dialog
      :openDialog="dialogReject"
      :onClicked="()=>sendChangeStatus(editedItem,'rejected')"
      :dialog-title="$t('schoolRequest.reject')"
      tool-bar-color="error"
      :onClose="closeAll"
    />

    <confirm-dialog
      :openDialog="dialogContacted"
      :onClicked="()=>sendChangeStatus(editedItem,'contacted')"
      :dialog-title="$t('schoolRequest.contacted')"
      tool-bar-color="warning"
      :onClose="closeAll"
    />
    <confirm-dialog
      :openDialog="dialogPostponed"
      :onClicked="()=>sendChangeStatus(editedItem,'postponed')"
      :dialog-title="$t('schoolRequest.accepted')"
      tool-bar-color="cyan"
      :onClose="closeAll"
    />
    <confirm-dialog
      :openDialog="dialogInterested"
      :onClicked="()=>sendChangeStatus(editedItem,'interested')"
      :dialog-title="$t('schoolRequest.accepted')"
      tool-bar-color="teal"
      :onClose="closeAll"
    />
    <confirm-dialog
      :openDialog="dialogNotInterested"
      :onClicked="()=>sendChangeStatus(editedItem,'not_interested')"
      :dialog-title="$t('schoolRequest.not_interested')"
      tool-bar-color="purple"
      :onClose="closeAll"
    />


    <view-dialog
      :dialog.sync="dialogView"
      :request="request"
    ></view-dialog>

    <transfer-dialog
      :dialog.sync="dialogTransfer"
      :request="request"
      @refreshTable="refreshTable"
    ></transfer-dialog>

    <note-dialog
      :dialog.sync="dialogViewNote"
      :request="request"
      @refreshTable="refreshTable"
    ></note-dialog>
  </v-container>
</template>
<script>
import Dialog from "../Schools/Dialog.vue";
import ViewDialog from "./Dialog.vue";
import TransferDialog from "./TransferDialog.vue";
import NoteDialog from "./NoteDialog";
import ConfirmDialog from "../../components/ConfirmDialog.vue";
import {ObjectToQuery} from "@/plugins/helper";
import it from "vue2-datepicker/locale/es/it";
import {formatDate} from "@/utils/filter";
export default {
  components: {ConfirmDialog, Dialog, ViewDialog, TransferDialog, NoteDialog},
  data() {
    return {
      loading: true,
      valid: true,
      dialog: false,
      dialogReject: false,
      dialogContacted: false,
      dialogAccept: false,
      dialogPostponed: false,
      dialogInterested: false,
      dialogNotInterested: false,
      dialogView: false,
      dialogViewNote: false,
      dialogTransfer: false,
      request: null,
      status_filter: ["pending", "contacted"],
      governorate_id: null,
      directorate_id: null,
      total: 0,
      options: {},
      directorates: [],
      governorates: [],
      editedIndex: -1,
      search: "",
      rules: {
        required: (value) => !!value || this.$t("ThisFieldIsRequired"),
      },
      schoolRequests: [],
      editedItem: {
        id: null,
        name: null,
        free: null,
        free_cause: null,
        domain: null,
        scid: null,
        directorate_id: null,
        owner: null,
        updated_at: null,
        directorate: null,
        types: [],
        groupschs: [],
        years: [],
        locality: null,
        district: null,
        village: null,
        closest_point: null,
        manager_phone: null,
        show_in_statistics: false,
        test: false,
        student_expected_count: null,
        server_id: null,
      },
      defaultItem: {
        id: null,
        name: null,
        free: null,
        free_cause: null,
        domain: null,
        scid: null,
        directorate_id: null,
        owner: null,
        updated_at: null,
        directorate: null,
        types: [],
        groupschs: [],
        years: [],
        locality: null,
        district: null,
        village: null,
        closest_point: null,
        manager_phone: null,
        show_in_statistics: false,
        test: false,
        student_expected_count: null,
        server_id: null,
      },
      resetValidation: 0,
    };
  },
  computed: {
    exportItems(){
      return this.schoolRequests.map((item)=>{
        let newItem = {}
        Object.assign(newItem, item);
        if(newItem.comments && newItem.comments.length > 0){
          newItem.note = newItem.comments[newItem.comments.length -1].comment;
        }
        if (newItem.status !== 'accepted' && newItem.status !== 'rejected'){
          newItem.updated_at = null;
        }
        newItem.created_at = formatDate(newItem.created_at);
        newItem.status = this.$t('schoolRequest.'+item.status)
        return newItem
      });
    },
    it() {
      return it
    },
    directorates_filtered() {
      return this.directorates
          .filter(directorate => directorate.governorate_id === this.governorate_id || !this.governorate_id);
    },
    headers() {
      return [
        {text: this.$t("schoolRequest.school_name"), value: "school_name"},
        {text: this.$t("schoolRequest.governorate_id"), value: "governorate.name"},
        {text: this.$t("schoolRequest.directorate_id"), value: "directorate.name"},
        {text: this.$t("schoolRequest.student_count"), value: "student_count"},
        {text: this.$t("schoolRequest.manager_name"), value: "manager_name"},
        {text: this.$t("schoolRequest.status"), value: "status"},
        {text: this.$t("schoolRequest.created_at"), value: "created_at"},
        // {text: this.$t("schoolRequest.updated_at"), value: "updated_at"},
        {text: this.$t("schoolRequest.note"), value: "note"},
        {text: "", value: "actions"},
      ];
    },
    status() {
      return [
        {
          value: ['pending'],
          label: this.$t('schoolRequest.pending')
        },
        {
          value: ['accepted'],
          label: this.$t('schoolRequest.accepted')
        },
        {
          value: ['contacted'],
          label: this.$t('schoolRequest.contacted')
        },
        {
          value: ['rejected'],
          label: this.$t('schoolRequest.rejected')
        },
        {
          value: ['postponed'],
          label: this.$t('schoolRequest.postponed')
        },
        {
          value: ['interested'],
          label: this.$t('schoolRequest.interested')
        },
        {
          value: ['not_interested'],
          label: this.$t('schoolRequest.not_interested')
        },
        {
          value: ["pending", "contacted"],
          label: this.$t('schoolRequest.pending_contacted')
        },
      ];
    },
  },
  created() {
    if (!this.$store.getters.isInRole(105)) {
      this.$router.push({name: "notauthorize"});
    }
    this.loading = true;
    this.getDirectorates();
    this.GetGovernorates();
    // this.refreshTable();
  },
  watch: {
    search: {
      handler() {
        this.refreshTable();
      }
    }
  },
  methods: {
    editItem(item) {
      this.editedItem = Object.assign(this.editedItem, {
        request_id: item.id,
        name: item.school_name,
        directorate_id: item.directorate_id,
        owner: item.owner,
        types: item.types,
        locality: item.locality,
        district: item.district,
        village: item.village,
        closest_point: item.closest_point,
        manager_phone: item.manager_phone,
        manager_name: item.manager_name,
        student_expected_count: item.student_count,
      });
      this.dialog = true;
    },
    GetGovernorates() {
      this.$store
          .dispatch("GetUserGovernorates")
          .then((data) => {
            this.governorates = data;
          })
          .finally(() => {
            //   this.loading = false;
          });
    },
    getDirectorates() {
      this.$store
          .dispatch("GetUserDirectorates")
          .then((data) => {
            this.directorates = data;
            // this.directorates.push({
            //   id: null,
            //   name: this.$t("all"),
            // });
          })
          .finally(() => {
            // this.loading = false;
          });
    },
    viewItem(item) {
      this.request = item;
      this.dialogView = true;
    },
    viewItemNote(item) {
      this.request = item;
      this.dialogViewNote = true;
    },
    transferItem(item) {
      this.request = item;
      this.dialogTransfer = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.resetValidation += 1;
    },
    changeStatus(item, $status) {
      this.editedIndex = this.schoolRequests.indexOf(item);
      this.editedItem = {
        id: item.id,
        name: item.school_name
      };

      switch ($status) {
        case "accepted":
          Object.assign(this.editedItem, item); //
          this.editedIndex = -1; // these two lines because the handle of accepted state different
          this.dialogAccept = true;
          break;
        case "rejected":
          this.dialogReject = true;
          break;
        case "contacted":
          this.dialogContacted = true;
          break;
        case "postponed":
          this.dialogPostponed = true;
          break;
        case "interested":
          this.dialogInterested = true;
          break;
        case "not_interested":
          this.dialogNotInterested = true;
          break;
      }
    },
    closeAll() {
      this.dialogAccept = false;
      this.dialogReject = false;
      this.dialogContacted = false;
      this.dialogPostponed = false;
      this.dialogInterested = false;
      this.dialogNotInterested = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    sendChangeStatus(item,status) {
      this.$axios
          .post(`schoolRequests/${item.id}`, {status: status})
          .then(() => {
            this.refreshTable();
          });

      this.closeAll();
    },
    refreshTable() {
      this.dialog = false;
      this.dialogView = false;
      this.dialogTransfer = false;
      this.dialogReject = false;
      this.loading = true;
      let conditions = {
        ...this.options,
        search: this.search
      };
      if (this.status_filter) {
        conditions.status = this.status_filter;
      }
      if (this.directorate_id) {
        conditions.directorate_id = this.directorate_id;
      }
      if (this.governorate_id) {
        conditions.governorate_id = this.governorate_id;
      }
      const query = ObjectToQuery(conditions);
      this.$axios
          .get(`schoolRequests?${query}`, {noToast: true, failureToast: true})
          .then((response) => {
            this.schoolRequests = response.data.data.data;
            this.total = response.data.data.total;
          }).catch(() => {
        this.schoolRequests = [];
      })
          .finally(() => {
            this.$store.dispatch('GetUserAlerts', true);
            this.loading = false;
          });
    },
    async openWhatsapp(item) {
      this.optionsLoading = true
      try {

        let phone = item.authorized_phone ?? item.manager_phone
        let text = ''
        if (!phone) return;
        phone = phone.replace(/\s+/g, "");
        phone = phone = phone.replace(/[٠-٩]/g, d => "0123456789"["٠١٢٣٤٥٦٧٨٩".indexOf(d)]);
        phone = phone.replace(/^[^\d+]+/, "");
        phone = phone.replace(/^\+?964|^0964|^0/, "")
        phone = phone.replace(/\D/g, "");

        const encodedText = encodeURIComponent(text);
        const waMe = `https://wa.me/${phone}${text ? `?text=${encodedText}` : ''}`;
        const whatsappScheme = `whatsapp://send?phone=${phone}${text ? `&text=${encodedText}` : ''}`;

        const ua = navigator.userAgent || '';
        const isAndroid = /Android/i.test(ua);
        // const isChrome = /Chrome\//i.test(ua) && !/Edge\//i.test(ua);

        // Android Chrome: use intent with explicit fallback URL (cleanest)
        if (isAndroid) {
          const fallback = encodeURIComponent(waMe);
          // intent URL instructs Chrome to open the package, or fallback to browser URL
          const intentUrl = `intent://send?phone=${phone}${text ? `&text=${encodedText}` : ''}#Intent;package=com.whatsapp;scheme=whatsapp;S.browser_fallback_url=${fallback};end`;
          window.location.href = intentUrl;
          return;
        }

        // Otherwise: try opening the whatsapp:// scheme and fallback to wa.me after timeout.
        // Note: browsers may prompt user or block; a user gesture (click) is ideal.
        // Try using location (may open app on mobile)
        try {
          window.location.href = whatsappScheme;
          return;
        } catch (e) {
          // some browsers block direct assignment
        }

        // Fallback to wa.me after small delay.
        // Timeout should be long enough for app to open (e.g. 1.2s). Adjust if needed.
        setTimeout(() => {
          // If user is on desktop, open web.whatsapp in a new tab for better UX
          const isDesktop = !/Mobi|Android|iPhone|iPad|iPod/i.test(ua);
          if (isDesktop) {
            window.open(waMe, '_blank');
          } else {
            // mobile fallback: replace location so back button isn't weird
            window.location.href = waMe;
          }
        }, 1200);
      } finally {
        this.optionsLoading = false
      }
    },
  },
};
</script>
